import { create } from "zustand"
import { persist, createJSONStorage } from "zustand/middleware"
import {
  DomainTypeEnum,
  TranslateLanguageTypeEnum,
} from "./translation.types"

export interface DocumentJobInfo {
  jobId: string
  sourceTitle: string
  sourceLanguage: TranslateLanguageTypeEnum
  targetLanguage: TranslateLanguageTypeEnum
  domain: DomainTypeEnum
  inputPath: string
  engine?: string
}

interface DocumentJobStore {
  selectedJob: DocumentJobInfo | null
  setSelectedJob: (job: DocumentJobInfo) => void
}

/**
 * 이 스토어가 sessionStorage에 쓰는 키.
 *
 * 담고 있는 내용(jobId, sourceTitle, inputPath)은 로그인한 사람의 것이지만 지금은
 * `SESSION_STORAGE_KEYS`에 없다. 넣으면 세션 종료 시 지워지는 대상이 바뀌므로 이 PR
 * 범위 밖이고, BeringLab/bering-console-v2#1653에서 다룬다. 그와 별개로 상수로 뽑은
 * 이유는 persist 이름을 리터럴로 두면 목록과 철자가 어긋나도 아무도 모르기 때문이다.
 */
const DOCUMENT_JOB_STORE_KEY = "document-job-store"

export const useDocumentJobStore = create<DocumentJobStore>()(
  persist(
    (set) => ({
      selectedJob: null,
      setSelectedJob: (job) => set({ selectedJob: job }),
    }),
    {
      name: DOCUMENT_JOB_STORE_KEY,
      storage: createJSONStorage(() => sessionStorage),
    }
  )
)
